module.exports = __webpack_public_path__ + "img/f22.85bc2e1f.jpg";